import { Checkbox, FormControlLabel, TextField } from '@mui/material';
import React from 'react';
import { Control, Controller, FieldErrors, useWatch } from 'react-hook-form';

import { ProductFormData } from '../../../models/Product';

type Props = {
  control: Control<ProductFormData>;
  errors: FieldErrors;
};

function PackageSectionForm({ control, errors }: Props) {
  const packaged = useWatch({ control, name: 'packaged' });

  return (
    <div className={`space-y-4 flex flex-col`}>
      <Controller
        name="packaged"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                color="primary"
              />
            }
            label="Produkt zapakowany w wymiarowe opakowanie"
          />
        )}
      />
      {packaged ? (
        <>
          <Controller
            name="packageDimensions"
            control={control}
            rules={{
              required: 'Wymiary opakowania są wymagane',
              validate: (value) =>
                (Array.isArray(value) &&
                  value.length === 3 &&
                  value.every((dim) => typeof dim === 'number' && dim > 0)) ||
                'Podaj poprawne wymiary (3 liczby dodatnie)',
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Wymiary opakowania (długość, szerokość, wysokość) [cm]"
                error={!!errors.packageDimensions}
                helperText={
                  errors.packageDimensions
                    ? String(errors.packageDimensions.message)
                    : 'Podaj wymiary jako 3 liczby oddzielone przecinkami'
                }
                onChange={(e) => {
                  const value = e.target.value.split(',').map(Number);
                  field.onChange(value);
                }}
              />
            )}
          />

          <Controller
            name="packageWeight"
            control={control}
            rules={{
              required: 'Masa opakowania jest wymagana',
              validate: (value) =>
                Number(value) >= 0.01 || 'Wartość musi być co najmniej 0.01',
            }}
            render={({ field }) => (
              <TextField
                {...field}
                type="number"
                label="Masa opakowania [kg]"
                error={!!errors.packageWeight}
                helperText={
                  errors.packageWeight
                    ? String(errors.packageWeight.message)
                    : ''
                }
                inputProps={{ min: 0.01, step: 0.01 }}
              />
            )}
          />
        </>
      ) : (
        <Controller
          name="singleItemDeliveryCost"
          control={control}
          rules={{
            required: 'Koszt dostawy pojedynczego produktu jest wymagany',
            validate: (value) =>
              Number(value) >= 0.01 || 'Wartość musi być co najmniej 0.01',
          }}
          render={({ field }) => (
            <TextField
              {...field}
              type="number"
              label="Koszt dostawy pojedynczego produktu [PLN]"
              error={!!errors.singleItemDeliveryCost}
              helperText={
                errors.singleItemDeliveryCost
                  ? String(errors.singleItemDeliveryCost.message)
                  : ''
              }
              inputProps={{ min: 0.01, step: 0.01 }}
            />
          )}
        />
      )}
    </div>
  );
}

export default PackageSectionForm;
